import React from 'react';

const ExecutiveCommandCenter = React.lazy(() => import('pages/ExecutiveCommandCenter/ExecutiveCommandCenter'));
const ExecutiveDailyReport = React.lazy(() => import('pages/ExecutiveCommandCenter/ExecutiveDailyReport'));
const ExecutiveKpiPlan = React.lazy(() => import('pages/ExecutiveKpiPlan/ExecutiveKpiPlan'));
const ExecutivePlanSimulation = React.lazy(() => import('pages/ExecutivePlanSimulation/ExecutivePlanSimulation'));
const BhytAttendanceControl = React.lazy(() => import('pages/BhytAttendanceControl/BhytAttendanceControl'));
const BhytAttendanceVoucher = React.lazy(() => import('pages/BhytAttendanceControl/BhytAttendanceVoucher'));
const InpatientMedicalRecord = React.lazy(() => import('pages/InpatientMedicalRecord/InpatientMedicalRecord'));
const InpatientMedicalRecordDetail = React.lazy(() => import('pages/InpatientMedicalRecord/InpatientMedicalRecordDetail'));
const ClinicalResultNotificationDetail = React.lazy(() => import('pages/ClinicalResultNotification/ClinicalResultNotificationDetail'));

const executiveCommandCenterRoute = [
  {
    path: '/executive-command-center',
    exact: true,
    name: 'Trung tâm điều hành',
    function: 'EXECUTIVE_COMMAND_CENTER_VIEW',
    any: process.env.NODE_ENV === 'development',
    component: ExecutiveCommandCenter,
  },
  {
    path: '/executive-daily-reports',
    exact: true,
    name: 'Báo cáo ngày bệnh viện',
    function: 'EXECUTIVE_COMMAND_CENTER_VIEW',
    any: process.env.NODE_ENV === 'development',
    component: ExecutiveDailyReport,
  },
  {
    path: '/executive-kpi-plans',
    exact: true,
    name: 'Kế hoạch chỉ tiêu',
    function: 'EXECUTIVE_KPI_PLAN_VIEW',
    any: process.env.NODE_ENV === 'development',
    component: ExecutiveKpiPlan,
  },
  {
    path: '/executive-plan-simulation',
    exact: true,
    name: 'Mô phỏng & phân bổ kế hoạch',
    function: 'EXECUTIVE_PLAN_SIMULATION_VIEW',
    any: process.env.NODE_ENV === 'development',
    component: ExecutivePlanSimulation,
  },
  {
    path: '/bhyt-attendance-control',
    exact: true,
    name: 'Kiểm soát công – y lệnh BHYT',
    function: 'BHYT_ATTENDANCE_CONTROL_VIEW',
    any: process.env.NODE_ENV === 'development',
    component: BhytAttendanceControl,
  },
  {
    path: '/bhyt-attendance-control/voucher',
    exact: true,
    name: 'Chi tiết phiếu HIS',
    function: 'BHYT_ATTENDANCE_CONTROL_VIEW',
    any: process.env.NODE_ENV === 'development',
    component: BhytAttendanceVoucher,
  },
  {
    path: '/inpatient-medical-records',
    exact: true,
    name: 'Hồ sơ bệnh án nội trú',
    function: 'INPATIENT_MEDICAL_RECORD_VIEW_SELF|INPATIENT_MEDICAL_RECORD_VIEW_DEPARTMENT|INPATIENT_MEDICAL_RECORD_VIEW_ALL',
    any: false,
    component: InpatientMedicalRecord,
  },
  {
    path: '/inpatient-medical-records/:encounterId',
    exact: true,
    name: 'Chi tiết hồ sơ bệnh án nội trú',
    function: 'INPATIENT_MEDICAL_RECORD_VIEW_SELF|INPATIENT_MEDICAL_RECORD_VIEW_DEPARTMENT|INPATIENT_MEDICAL_RECORD_VIEW_ALL',
    any: false,
    component: InpatientMedicalRecordDetail,
  },
  {
    path: '/clinical-result-notification/:publicToken',
    exact: true,
    name: 'Kết quả cận lâm sàng',
    any: true,
    component: ClinicalResultNotificationDetail,
  },
];

export default executiveCommandCenterRoute;
